module.exports = __webpack_public_path__ + "static/media/maximize.a92e32ab.svg";